module.exports = __webpack_public_path__ + "static/media/Car-red.de3ccc0a.svg";